import React, { Component } from 'react';
import { Form, Input, Label, Button, Dropdown } from '../../../Form';

import withTranslations from '../../../../utils/translations/withTranslations';

class Ergometertest extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: true,
      test: this.getAvailableTests(
        this.calculateAge(props.allData['pilot'].birthday)
      )[0]
    };
  }

  next() {
    this.props.saveItem(this.form.formData());
    this.props.next();
  }

  calculateAge(str) {
    const parts = str.split('/');
    var birthday = new Date(
      parseInt(parts[2], 10),
      parseInt(parts[1], 10) - 1,
      parseInt(parts[0], 10)
    );

    var ageDifMs = Date.now() - birthday.getTime();
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  setTest(event) {
    this.setState({ test: event.target.value });
  }

  getAvailableTests(age) {
    return age < 15 ? ['martinet', 'steptest'] : ['loopband', 'cycloergometer'];
  }

  render() {
    const { translate, data = {}, previous, allData } = this.props;
    const { isValid, test } = this.state;

    const age = this.calculateAge(allData['pilot'].birthday); // TODO

    return (
      <div className="Ergometertest">
        <Form
          ref={form => (this.form = form)}
          onValidationChange={valid => this.setState({ isValid: valid })}
          className="Ergometertest__Form"
        >
          <h1>
            {translate('fiche.ergometertest.title')}{' '}
            {age < 15 ? '(-15)' : '(+15)'}
          </h1>

          <Label text={translate('fiche.ergometertest.type')} />

          <Dropdown
            name="test"
            data={this.getAvailableTests(age)}
            rules={['required']}
            defaultValue={data.test}
            onChange={value => this.setTest(value)}
          />

          {test === 'martinet' && (
            <div>
              <Label text={translate('fiche.ergometertest.knee_bends')} />
              <Dropdown
                name="knee_bends"
                data={[10, 30]}
                rules={['required']}
                defaultValue={data.knee_bends}
              />
            </div>
          )}

          {test === 'steptest' && (
            <div>
              <Label text={translate('fiche.ergometertest.minutes')} />
              <Dropdown
                name="minutes"
                data={['1', '3']}
                rules={['required']}
                defaultValue={data.minutes}
              />
            </div>
          )}

          {['martinet', 'steptest'].includes(test) && (
            <div>
              <Label text={translate('fiche.ergometertest.pulse_5')} />
              <Input
                name="pulse_0"
                rules={['required']}
                defaultValue={data.pulse_0}
              />

              <Label
                text={translate('fiche.ergometertest.pulse_1_recuperation')}
              />
              <Input
                name="pulse_1"
                rules={['required']}
                defaultValue={data.pulse_1}
              />

              <Label
                text={translate('fiche.ergometertest.pulse_2_recuperation')}
              />
              <Input
                name="pulse_3"
                rules={['required']}
                defaultValue={data.pulse_3}
              />
            </div>
          )}

          {['loopband', 'cycloergometer'].includes(test) && (
            <div>
              <h2>{translate('fiche.ergometertest.during_effort')}</h2>
              <div className="Form__Horizontal">
                <div className="Form__Horizontal__Item">
                  <Label text={translate('fiche.ergometertest.stress_1')} />
                  <Input name="stress_1" defaultValue={data.stress_1} />
                </div>
                <div className="Form__Horizontal__Item">
                  <Label text={translate('fiche.ergometertest.pulse_1')} />
                  <Input name="pulse_1" defaultValue={data.pulse_1} />
                </div>
              </div>

              <div className="Form__Horizontal">
                <div className="Form__Horizontal__Item">
                  <Label text={translate('fiche.ergometertest.stress_2')} />
                  <Input name="stress_2" defaultValue={data.stress_2} />
                </div>
                <div className="Form__Horizontal__Item">
                  <Label text={translate('fiche.ergometertest.pulse_2')} />
                  <Input name="pulse_2" defaultValue={data.pulse_2} />
                </div>
              </div>

              <div className="Form__Horizontal">
                <div className="Form__Horizontal__Item">
                  <Label text={translate('fiche.ergometertest.stress_3')} />
                  <Input name="stress_3" defaultValue={data.stress_3} />
                </div>
                <div className="Form__Horizontal__Item">
                  <Label text={translate('fiche.ergometertest.pulse_3')} />
                  <Input name="pulse_3" defaultValue={data.pulse_3} />
                </div>
              </div>

              <div className="Form__Horizontal">
                <div className="Form__Horizontal__Item">
                  <Label text={translate('fiche.ergometertest.stress_4')} />
                  <Input name="stress_4" defaultValue={data.stress_4} />
                </div>
                <div className="Form__Horizontal__Item">
                  <Label text={translate('fiche.ergometertest.pulse_4')} />
                  <Input name="pulse_4" defaultValue={data.pulse_4} />
                </div>
              </div>

              <div className="Form__Horizontal">
                <div className="Form__Horizontal__Item">
                  <Label text={translate('fiche.ergometertest.stress_5')} />
                  <Input name="stress_5" defaultValue={data.stress_5} />
                </div>
                <div className="Form__Horizontal__Item">
                  <Label text={translate('fiche.ergometertest.pulse_5')} />
                  <Input name="pulse_5" defaultValue={data.pulse_5} />
                </div>
              </div>

              <Label text={translate('fiche.ergometertest.blood_pressure')} />
              <Input
                name="blood_pressure"
                rules={['required']}
                defaultValue={data.blood_pressure}
              />
              <Label text={translate('fiche.ergometertest.ecg')} />
              <Input name="ecg" rules={['required']} defaultValue={data.ecg} />

              <h2>{translate('fiche.ergometertest.recuperation')}</h2>
              <Label
                text={translate('fiche.ergometertest.pulse_1_recuperation')}
              />
              <Input
                name="pulse_recuperation_1"
                rules={['required']}
                defaultValue={data.pulse_recuperation_1}
              />
              <Label
                text={translate('fiche.ergometertest.pulse_2_recuperation')}
              />
              <Input
                name="pulse_recuperation_2"
                rules={['required']}
                defaultValue={data.pulse_recuperation_2}
              />
              <Label
                text={translate(
                  'fiche.ergometertest.blood_pressure_recuperation'
                )}
              />
              <Input
                name="blood_pressure_recuperation"
                rules={['required']}
                defaultValue={data.blood_pressure_recuperation}
              />
              <Label text={translate('fiche.ergometertest.ecg_recuperation')} />
              <Input
                name="ecg_recuperation"
                rules={['required']}
                defaultValue={data.ecg_recuperation}
              />
            </div>
          )}

          <Button
            solid
            className="Form__Button"
            disabled={!isValid}
            onClick={() => this.next()}
          >
            {translate('fiche.next')}
          </Button>
          <Button
            transparant
            className="Form__Button"
            onClick={() => previous()}
          >
            {translate('fiche.previous')}
          </Button>
        </Form>
      </div>
    );
  }
}

export default withTranslations(Ergometertest);
